import validate from "/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.14.1592_eslint@8.57.0_rollup@4.34.8_typescript@5.9.3_vue-tsc@2.1.6/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.14.1592_eslint@8.57.0_rollup@4.34.8_typescript@5.9.3_vue-tsc@2.1.6/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "validate-route-tenant-id": () => import("/home/vsts/work/1/s/.app/middleware/validateRouteTenantId.ts")
}